import styled from 'styled-components'
import { Button as OriginalButton } from 'reactstrap'

import { COLOURS } from 'resources'
import { ReactComponent as RightArrowIconWhite } from 'resources/images/icons/right-arrow-icon-white.svg'

export const BUTTON_VARIANTS = {
  primary: {
    bg: COLOURS.primaryBlue,
    fg: COLOURS.neutralWhite,
    disabledBg: COLOURS.neutralGrey3,
    disabledFg: COLOURS.neutralGrey5,
  },
  secondary: {
    bg: COLOURS.secondaryPurple2,
    fg: COLOURS.primaryBlue,
  },
  transparent: {
    bg: COLOURS.transparent,
    fg: COLOURS.primaryBlue,
    disabledBg: COLOURS.transparent,
  },
  primaryYellow: {
    bg: COLOURS.primaryYellow,
    fg: COLOURS.black,
  },
  transparentRed: {
    bg: COLOURS.transparent,
    fg: COLOURS.secondaryRed1,
    disabledBg: COLOURS.transparent,
  },
  transparentPurple1: {
    bg: COLOURS.transparent,
    fg: COLOURS.secondaryPurple1,
    disabledBg: COLOURS.transparent,
  },
  transparentPurple2: {
    bg: COLOURS.transparent,
    fg: COLOURS.secondaryPurple2,
    disabledBg: COLOURS.transparent,
  },
  secondaryPurple: {
    bg: COLOURS.secondaryPurple1,
    fg: COLOURS.neutralWhite,
  },
  neutralBlack: {
    bg: COLOURS.neutralBlack,
    fg: COLOURS.neutralWhite,
  },
}

const getBgColor = (variant) => BUTTON_VARIANTS[variant]?.bg || BUTTON_VARIANTS.primary.bg
const getDisabledBgColor = (variant) => BUTTON_VARIANTS[variant]?.disabledBg || BUTTON_VARIANTS.primary.disabledBg

const getFgColor = (variant) => BUTTON_VARIANTS[variant]?.fg || BUTTON_VARIANTS.primary.fg
const getDisabledFgColor = (variant) => BUTTON_VARIANTS[variant]?.disabledFg || BUTTON_VARIANTS.primary.disabledFg

export const KilliIcon = styled.i`
  font-size: 24px;
  line-height: 1;
  margin-right: 5px;

  &::before {
    margin: 0;
  }
`

/**
 * @type OriginalButton
 */
export const Button = styled(OriginalButton)`
  display: flex;
  font-size: 18px;
  line-height: 20px;
  font-weight: bold;
  text-align: center;
  padding: 10px 18px;
  min-height: 50px;
  border: none;
  border-radius: 4px;
  transition: all 0.3s;
  align-items: center;
  justify-content: center;

  &.with-arrow {
    justify-content: space-between;
  }

  &:disabled {
    opacity: 1;
    cursor: not-allowed;
  }

  &:focus,
  &:hover {
    box-shadow: none;

    &:not(:disabled) {
      text-decoration: none;
      opacity: 0.7;
    }
  }

  && {
    background-color: ${({ variant }) => getBgColor(variant)};
    color: ${({ variant }) => getFgColor(variant)};

    &:disabled {
      background-color: ${({ variant }) => getDisabledBgColor(variant)};
      color: ${({ variant }) => getDisabledFgColor(variant)};
    }

    &:focus,
    &:hover {
      &:not(:disabled) {
        background-color: ${({ variant }) => getBgColor(variant)};
        color: ${({ variant }) => getFgColor(variant)};
      }
    }
  }
`

export const Arrow = styled(RightArrowIconWhite).attrs({
  className: 'arrow',
})`
  margin-left: 10px;
  rect {
    fill: ${({ disabled, variant }) => (disabled ? getDisabledFgColor(variant) : getFgColor(variant))};
  }
`
